/**
 * Created by Shen Mo on 2020/7/20
 */

const _equalCheck = (a, b) => a === b;
const memo = function (func, isEqual = _equalCheck) {
	let cached = false,
		lastContext = null,
		lastArgs = [],
		lastRes = [];
	const isEqualToLast = (newVal, index) => {
		return isEqual(newVal, lastArgs[index]);
	};
	return (...args) => {
		//入参不变，直接返回缓存的结果lastResult
		if (cached && lastContext === this && args.length === lastArgs.length && args.every(isEqualToLast)) {
			return lastRes;
		}

		cached = true;
		lastArgs = args;
		lastRes = func(...args);
		lastContext = this;
		return lastRes;
	};
};

const memoWithDependence = function (func, getDependence, options) {
	let deps = [];
	let res;
	const _debug = 'production' !== process.env.NODE_ENV;

	return () => {
		let depTime = _debug ? Date.now() : null;
		const newDeps = getDependence();
		const depsChanged = deps.length !== newDeps.length || deps.some((d, i) => d !== newDeps[i]);

		if (!depsChanged) {
			return res;
		}

		deps = newDeps;
		res = func(...newDeps);
		options?.onChange?.(res);

		let resultTime = _debug ? Date.now() : null;

		if (_debug && options?.key) {
			const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
			const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
			const resultFpsPercentage = resultEndTime / 16;

			const pad = (str, num) => {
				str = String(str);
				while (str.length < num) {
					str = ' ' + str;
				}
				return str;
			};

			console.info(
				`%c⏱ ${pad(resultEndTime, 5)} / ${pad(depEndTime, 5)} ms`,
				`
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`,
				options?.key,
			);
		}

		return res;
	};
};

memo.withDeps = memoWithDependence;

export default memo;
